import React from 'react';
import { Badge } from '../ui/badge';
import { feedbackStatusBadgeClass, feedbackStatusLabel } from '../../data/feedbackConstants';

export default function FeedbackStatusBadge({ status }) {
  return (
    <Badge variant="outline" className={feedbackStatusBadgeClass(status)}>
      {feedbackStatusLabel(status)}
    </Badge>
  );
}
